<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <v-container>
        <v-toolbar dense class="mb-2 indigo white--text" flat>
            <v-toolbar-title>Telehealth</v-toolbar-title>
        </v-toolbar>
        <v-row dense>
            <v-col md="12">
                <v-textarea
                    v-model="orgData.telehealth.emailSubject"
                    label="Email Subject"
                    :clearable="!readonly"
                    single-line
                    auto-grow
                    rows="1"
                    :readonly="readonly">
                </v-textarea>
            </v-col>
            <v-col md="12">
                <v-textarea
                    v-model="orgData.telehealth.emailFromAccount"
                    label="Email From Account"
                    :clearable="!readonly"
                    single-line
                    auto-grow
                    rows="1"
                    :readonly="readonly">
                </v-textarea>
            </v-col>
            <v-col md="12">
                <v-textarea
                    v-model="orgData.telehealth.emailBody"
                    label="Email Body"
                    :clearable="!readonly"
                    single-line
                    auto-grow
                    rows="1"
                    :readonly="readonly">
                </v-textarea>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default
    {
        name: 'org-telehealth',
        data: function ()
        {
            return {
            }
        },
        props:
        {
            readonly: true,
            orgData: {}
        }
    };
</script>

<style scoped>
</style>